import React from 'react';
import SamuraiGame from '../SamuraiGame';

const Click6SamuraiW = () => {
    return <SamuraiGame initialDrillIndex={10} />;
};

export default Click6SamuraiW;
